import { render } from "./Empty.vue?vue&type=template&id=26bf6133"
import script from "./Empty.vue?vue&type=script&lang=ts"
export * from "./Empty.vue?vue&type=script&lang=ts"
script.render = render

export default script